import React from 'react'

import VisitAudits from './VisitAudits'

export const CentreVisitAuditPage = () => (
  <VisitAudits
    kind="centreVisitAudits"
    formKind="centre"
    title="Centre Audit"
  />
)

export const HkAuditPage = () => (
  <VisitAudits
    kind="hkAudits"
    formKind="housekeeping"
    title="Housekeeping Audit"
    staffFields
  />
)
